import React, { FC } from "react";
import classnames from "classnames";
import uniqueId from "lodash/uniqueId";

import { ISwitchProps } from "./types";

import "./styles.scss";

export const Switch: FC<ISwitchProps> = ({
  className,
  id,
  checked,
  disabled,
  onChange,
}) => {
  return (
    <div className={classnames("ams-switch", className)}>
      <input
        type="checkbox"
        id={id}
        disabled={disabled}
        className="ams-switch-checkbox"
        checked={checked}
        onChange={onChange}
      />
      <label htmlFor={id} className="ams-switch-button" />
    </div>
  );
};

Switch.defaultProps = {
  id: uniqueId("ams-switch-"),
};
